export const BOOKING_CARD_CSS = /* css */ `
  .lk-booking-card {
    width: 100%;
    max-width: 304px;
    border-radius: 14px;
    overflow: hidden;
    background: var(--wg-bg);
    box-shadow: var(--wg-card-shadow);
    margin: 8px 0;
    animation: lk-card-in 0.4s ease backwards;
    transition: transform 0.15s ease-out, box-shadow 0.15s ease-out;
  }
  .lk-booking-card:hover {
    transform: scale(1.02);
    box-shadow: var(--wg-card-shadow-hover);
  }
  .lk-booking-card-image {
    height: 177px;
    background-size: cover;
    background-position: center;
    background-color: var(--wg-image-placeholder-bg);
  }
  .lk-booking-card-body {
    padding: 14px 14px 18px;
    display: flex;
    flex-direction: column;
    gap: 14px;
    color: var(--wg-card-fg);
  }
  .lk-booking-card-top {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
  .lk-booking-card-sport {
    font-size: 12px;
    font-weight: 600;
    line-height: 1;
    letter-spacing: 0.36px;
    color: var(--wg-fg-muted);    /* text-200 #8C95A2 */
    text-transform: uppercase;
  }
  .lk-booking-card-name {
    font-size: 16px;
    font-weight: 600;
    line-height: 1.5;
    letter-spacing: -0.32px;
    color: var(--wg-card-fg);     /* text-500 #061934 */
  }
  .lk-booking-card-rows {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
  .lk-booking-card-row {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 13px;
    line-height: 1.3;
    font-weight: 400;
    letter-spacing: -0.13px;
    color: var(--wg-card-fg-muted);  /* text-300 #586577 */
  }
  .lk-booking-card-icon {
    width: 16px;
    height: 16px;
    flex: 0 0 auto;
    color: var(--wg-card-fg-muted);
  }
  .lk-booking-card-cta {
    display: inline-block;
    padding: 10px 20px;
    background: var(--wg-cta-bg);
    color: var(--wg-fg);
    font-size: 13px;
    font-weight: 600;
    line-height: 1.3;
    letter-spacing: -0.13px;
    border-radius: 999px;
    text-align: center;
    text-decoration: none;
    align-self: center;
  }
  .lk-booking-card-cta:hover {
    background: var(--wg-cta-bg-hover);
  }
`;
